// extracted by mini-css-extract-plugin
var _1 = "office-switch__LUV2p";
export { _1 as "office-switch" }
